// extracted by mini-css-extract-plugin
export default {"UserGridItem":"UserGridItem_UserGridItem__RYeB7","limitText":"UserGridItem_limitText__zmJOi"};